<template>
  <SkeletonItem
    :skeleton-style="{
      width: '100%',
      height: '287px',
      borderRadius: '16px',
    }"
    :is-animated="true"
    skeleton-class="skeleton-img"
  />
  <SkeletonItem
    :skeleton-style="{
      width: '100%',
      height: '120px',
      borderRadius: '16px',
    }"
    :is-animated="true"
    skeleton-class="skeleton-title"
  />
  <SkeletonItem
    :skeleton-style="{
      width: '100%',
      height: '24px',
      borderRadius: '16px',
    }"
    :is-animated="true"
    skeleton-class="skeleton-time"
  />
  <SkeletonItem
    :skeleton-style="{
      width: '100%',
      height: '24px',
      borderRadius: '16px',
    }"
    :is-animated="true"
    skeleton-class="skeleton-hash"
  />
</template>

<script setup lang="ts">
import { SkeletonItem } from '@experience/core-skeleton-lib';
</script>

<style lang="scss" scoped>
.skeleton-title {
  margin-top: var(--alias-space-24, 24px);
}

.skeleton-time,
.skeleton-hash {
  margin-top: var(--alias-space-12, 12px);
}
</style>
